import functions from "../../Data/Functions"

export default {

    // Look up Rego Links
    LoadBQRegoLink: (Association) => {
        switch (Association) {
            case 180:   // Brisbane
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=aa9f1534-73c7-4619-a69d-e18bc4e57143&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=ee5277a24c6ee81f81a28f659bef8827'
                break;
            case 185:   // Gold Coast
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=beaee088-ad3e-4758-b367-f470f6422c7a&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=47a7bf0b89714800aa6649580ac91f88'
                break;
            case 188:   // Northside
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=155fb981-71f6-48a0-a53f-1da7ee78fb39&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=77e76ad3174c919048daa50895428adc'
                break;
            case 182:   // Moretn Bay
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=b726e7c4-220f-4e46-aeb9-de22d30d0edb&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=db4e291e2aed50f9f4af0baad0e9233e'
                break;
            case 177:   // South West
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=8d56a05f-8b53-44e8-a6fd-7b431c38ad51&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=189505f9c0ace093047d352e9291e02b'
                break;
            case 179:   // Sth Districts
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=75a115f4-90b6-461b-a3a5-aa0b9ce99f7a&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=608df562440f102ca9c0516e6983f5c8'
                break;
            case 193:   // Toowoomba
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=ebfe019d-bdc5-4830-b496-9fafaca73c2a&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=76bf2ce941475f66b927cd7cfe771ec8'
                break;
            case 195:   // USC RIP
                return 'https://registration.basketballconnect.com/userRegistration?organisationId=50ef414b-b434-4ff6-826f-f4fabd51745e&competitionId=92a230d6-d45e-43ca-a930-8f48f7e50f0c&key=61dd7c130e484c761904d3e60792f9f8'
                break;

            default:
                break;
        }
    },

    // Lookup Teams for each Conference
    LookupTeams: async (param) => {
        let SubCompetition = await functions.GetCodeBy({
            State_Champs: param.State_Champs,
            Type: 'Competitions',
            Gender: param.Gender
        }, true)
        param.State_Champs = SubCompetition[0].Code_id
        param.Type = "Teams"
        let Teams = await functions.GetCodeBy(param, true)
        return Teams
    },


    // General Variables
    PlayerAccred: 7141,
    CompType: ["Male Competition", "Female Competition"],
    PlayerRoles: ["GUARD", "FORWARD", "CENTER"],
    StaffRoles: ["Coach", "Assistant Coach", "Team Manager"],
    StaffRoleids: [3, 9, 10],
    StaffAccredids: [7142, 7143, 7144],
    ConfEndDate: '2024-07-15'
}